/*********************************************
 * Boutique Page Configuration
 *********************************************/

const scenePageMap = {
  home: '/',
  market: '/market',
  catering: '/catering',
  about: '/about',
  games: '/games',
  boutique: '/boutique'
};

const pageConfig = {
  initialScene: 'boutique',
  navigationMode: 'spa',
  history: true,
  scenePageMap,
  prefetchScenes: ['home', 'market', 'catering', 'about', 'games']
};

if (!window.__BUBAR_PAGE__) {
  window.__BUBAR_PAGE__ = pageConfig;
}

import('../core/page.js').catch(err => console.error('Failed to load page runtime', err));
